import React from "react";

import { HStack, Stack, Text, Flex, Link } from "@chakra-ui/react";
import { VisaLogo } from "../../atoms/VisaLogo";
import { MasterCardLogo } from "../../atoms/MasterCardLogo";
import { MdEmail, MdPhoneEnabled } from "../../customIcons";

const Banner = () => {
  return (
    <Stack px="16px" h="32px" bg="#3B2060" w="100%">
      <HStack my="auto" justifyContent="space-between">
        <Flex flexDir="row">
          <VisaLogo mr="8px" />
          <MasterCardLogo />
          {/* <HStack ml="8px">
            <Text color="#ffff" fontSize="12px">
              Expected Delivery: 3-4 Days
            </Text>
          </HStack> */}
        </Flex>
        <HStack>
          <Text color="#ffff" fontSize="12px">
            Business Hours: Monday - Friday: 9 AM - 6 PM EST
          </Text>
        </HStack>
        <HStack>
          <MdPhoneEnabled fill="#BA9FDF" w="20px" h="20px" />
          <Link href="tel:+1-844-226-8277" color="#ffff" fontSize="12px">
            +1-844-226-8277
          </Link>
          <MdEmail w="20px" h="20px" fill="white" />
          <Link
            href="mailto:info@medsupplysolutions.com"
            color="#ffff"
            fontSize="12px"
          >
            info@medsupplysolutions.com
          </Link>
        </HStack>
      </HStack>
    </Stack>
  );
};

export default Banner;
